// extracted by mini-css-extract-plugin
export default {"video-section":"d_j d-flex","video-section--header":"d_k","video-section__frame":"d_l ml-3"};